<template>
  <t-form labelWidth="90px">
    <CptData :data="attribute.cptTableData" :cptDataForm="cptDataForm"/>
    <t-form-item label="自动切换">
      <t-switch v-model="attribute.autoSwitch" size="small" :label="['开', '关']"/>
    </t-form-item>
    <t-form-item label="切换间隔(s)" v-show="attribute.autoSwitch">
      <t-input-number :min="1" :max="100" v-model="attribute.interval" size="small" :decimal-places="0"/>
    </t-form-item>
    <t-form-item label="间距">
      <t-input-number :min="0" :max="500" v-model="attribute.space" size="small" :decimal-places="0"/>
    </t-form-item>
    <t-form-item label="背景">
      <t-color-picker :colorModes="['monochrome']" format="HEX" v-model="attribute.bgColor" size="small"/>
    </t-form-item>
    <t-form-item label="高亮背景">
      <t-color-picker :colorModes="['monochrome']" format="HEX" v-model="attribute.bgColorActive" size="small"/>
    </t-form-item>
  </t-form>
</template>

<script>
import CptData from '@/components/element/options/comp/cpt-data'
export default {
  name: "cpt-navigator-option",
  components: {CptData},
  props: {attribute: Object,cptDataForm:Object,},
}
</script>

<style scoped>

</style>
